/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState } from 'react'
import Header from './Header'
import Button from '../../../components/Button'
import ErrorMessage from '../../../components/ErrorMessage';
import { useNavigate } from 'react-router-dom';

export default function LoginPage({
    submitSelected,
    setsubmitSelected,
    handleInput,
    loginFields,
    loading,
    loginError,
    handleLogin,
    errorState
}) {
    const { email, password } = loginFields
    const [type, settype] = useState('password');
    const handleClick = (e) => {
        e.preventDefault()
        settype('password');
        handleLogin(e)
    }
    const isError = (key) => submitSelected && !loading && (key === '')
    const navigate = useNavigate();
    const emailValidate = () => isError(email) || submitSelected && (loginError === 'Invalid email address or password' || loginError === 'Deactivated account. Please contact support')
    const passValidate = () => isError(password) || (submitSelected && !loading && loginError === 'Invalid email address or password')

    return (
        <>
            <Header /><div className='flex justify-center items-center ' style={{ height: '90vh' }}>
                <div className='min-h-[387px] min-w-[561px]  bg-[#ffff] '>
                    <form onSubmit={handleClick}>

                        <div className='flex flex-col rounded-lg pb-8 px-[117px] '>
                            <h2 className='text-[#666666] text-xl font-semibold pt-[38px] text-center'>Admin Login</h2>
                            <p className="text-[#666]">Please fill in your unique admin login details below</p>
                            <div className='px-[13.5px]'>
                                <div className='flex flex-col pt-7 pb-4'>
                                    <div className='relative'>
                                        <input
                                            id="email"
                                            data-testid="email"
                                            value={email.trim()}
                                            onFocus={() => setsubmitSelected(false)}
                                            placeholder=''
                                            autoComplete='off'
                                            onChange={(e) => handleInput('email', e.target.value)}
                                            // className={`w-full ${emailValidate() || loginError !== '' ? 'input-error text-[#FC4523]' : 'input-border'}  pl-[15px] pr-[42px] rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            className={`w-full ${emailValidate() ? 'input-error text-[#FC4523]' : 'input-border'} font-semibold  pl-3 pr-[52px]  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                        />

                                        {/* <label for="email" class={`px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: ${emailValidate()?'text-[#FC4523] ':'text-[#1F1F1F]'} peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:left-1`}>Email address</label> */}
                                        <label for="email" class={` ${emailValidate() ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute block  peer-focus:font-normal ${email?.length > 0 ? 'font-normal' : 'font-semibold'}  leading-tight text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}>Email address</label>
                                        <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5 outline-none">
                                            <img loading="lazy" src={`/assets/images/${emailValidate() ? 'email-error.svg' : 'email.svg'}`} alt="password-show" className="password-show outline-0" />

                                        </button>
                                    </div>
                                    {isError(email) && <ErrorMessage error message={loginError || 'This field is required'} />}

                                    {submitSelected && loginError !== '' && !loading && loginError === 'Deactivated account. Please contact support' && <ErrorMessage error message={loginError} />}

                                </div>

                                <div className='flex flex-col py-4'>
                                    <div className='relative'>
                                        <input
                                            id="password"
                                            type={type}
                                            data-testid="password"
                                            value={password.trim()}
                                            placeholder=''
                                            autoComplete='off'
                                            onFocus={() => setsubmitSelected(false)}
                                            onChange={(e) => handleInput('password', e.target.value)}

                                            className={`w-full ${passValidate() ? 'input-error' : 'input-border'}  font-semibold  pl-3 pr-[52px]  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`} />
                                        {/* <label for="password" class={`px-4  absolute ${passValidate() ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} outline-none block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F] peer-focus:dark:text-[#1F1F1F] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:left-1`}>Password</label> */}
                                        <label for="password" class={`peer-focus:dark: ${passValidate() ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute text-[#1F1F1F] block  peer-focus:font-normal ${password?.length > 0 ? 'font-normal' : 'font-semibold'}  leading-tight text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}>Password</label>

                                        <button type="button" className="cursor-pointer outline-none absolute top-[50%] -translate-y-[50%] right-3.5 ">
                                            {type === 'text' ? <img loading="lazy" src={`/assets/images/${passValidate() ? 'eye-error.svg' :'eye.svg'}`} alt="password-show" className="password-show outline-none" onClick={() => settype('password')} />
                                                : <img loading="lazy" src={`/assets/images/${passValidate() ? 'eye-open-error.svg' : 'eye-open.svg'}`} alt="password-hide" className="password-show outline-none" onClick={() => settype('text')} />}
                                        </button>

                                    </div>
                                    {submitSelected && !loading && loginError !== '' && loginError !== 'Deactivated account. Please contact support' && (password === '') && <ErrorMessage error message={loginError || 'Invalid email address or password'} />}

                                </div>
                                <span className='float-right text-xs font-semibold pb-4 cursor-pointer' data-testid='forgot-password-link' onClick={() => navigate("/forgot-password")}>Forgot password</span>
                                <div className='w-full whitespace-nowrap pt-3'>
                                    {submitSelected && !loading && loginError !== '' && loginError !== 'Deactivated account. Please contact support' && (loginError === 'Invalid email address or password') && <ErrorMessage error message={loginError || 'Invalid email address or password'} />}
                                </div>
                                <Button
                                    text="Login"
                                    type="submit"
                                    testId="login-btn"
                                    disabled={loading}
                                    handleClick={handleClick}
                                    loading={loading}
                                    classKey={`flex item-center justify-center w-full ${isError(password) ? 'bg-[#9E2064] opacity-[0.3]' : 'bg-[#9E2064]'} py-3 rounded-lg mt-5 text-f2 font-semibold text-[#ffffff] login`} />

                            </div>
                        </div>
                    </form>

                </div>
            </div></>
    )
}
